
export interface ExchangeRate {
    id: string;
    exchangeDate: string;
    sellRate: number;
    buyRate: number;
    closingBuyRate: number;
    closingSellRate: number;
    createdAt: string;
    updatedAt: string;
}

// export interface ExchangeRateModel {
//     id?: string;
//     exchangeDate: string;
//     sellRate: number;
//     buyRate: number;
//     closingBuyRate: number;
//     closingSellRate: number;
//     createdAt: string;
//     updatedAt: string;
// }

// export interface ExchangeRateCommandModel {
//     id?: string;
//     exchangeDate: string;
//     sellRate: number;
//     buyRate: number;
//     closingBuyRate?: number;
//     closingSellRate?: number;
// }
